import '@/styles/lib-mixins.less'
import '@/styles/lib-reset.less'
import '@/styles/lib-rem.less'
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import 'vant/lib/index.less'
import Button from 'vant/lib/button'
import {
  Tabbar,
  TabbarItem,
  Search,
  Cell,
  CellGroup,
  Card,
  Popup,
  Tab,
  Tabs,
  List,
  Collapse,
  CollapseItem,
  Image as VanImage,
  Dialog,
  Toast,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  Uploader,
  Picker,
  Loading,
  Calendar,
  ActionSheet,
  Icon,
  DatetimePicker,
  SwipeCell,
  Swipe,
  SwipeItem,
  Field
} from 'vant'

Vue.use(Button)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Search)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Card)
Vue.use(Popup)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(List)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Dialog)
Vue.use(Toast)
Vue.use(VanImage)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Uploader)
Vue.use(Picker)
Vue.use(Loading)
Vue.use(Calendar)
Vue.use(ActionSheet)
Vue.use(SwipeCell)
Vue.use(Icon)
Vue.use(DatetimePicker)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Field)
Vue.use(VueClipboard)
